import React from 'react';
import LegalDocument from '../components/LegalDocument';

const TermsOfService = () => {
  return <LegalDocument type="terms" />;
};

export default TermsOfService;
